<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div class="row row-period-consumption-period align-items-end g-2">
          <div id="textPeriodConsumptionChart" class="col-12 col-md-7">
            <div class="component-title">
              <span class="text">{{
                $t('pages.plan.periodConsumptionTitlePersonalized')
              }}</span>
              <p style="font-size: 0.8rem; margin-top: 10px">
                {{ $t('pages.plan.periodConsumptionDescriptionPersonalized') }}
              </p>
            </div>
          </div>

          <div class="col-12 col-md-5">
            <aol-select
              id="selectPeriodTypeConsumption"
              v-model="selectedPeriodType"
              @input="onPeriodTypeChange"
              :options="availableConsumptionPeriods"
              label="label"
              :reduce="(month) => month.value"
              class="form-select mb-4"
              style="
                width: 100%;
                margin: 0px;
                padding: 4px;
                background-color: transparent;
                border: none;
              "
            >
              <template v-slot:selected-option="{ label }">
                <span style="gap: 8px; padding: 8px; align-items: center">
                  <!-- eslint-disable max-len -->
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="14"
                    height="18"
                    viewBox="0 0 14 18"
                    fill="none"
                  >
                    <path
                      d="M3.09023 15.8977L2.59453 15.6164L2.07422 15.8484L1.125 16.2703V1.72969L2.07422 2.15156L2.59453 2.38359L3.09023 2.10234L4.53516 1.27617L6.24727 2.13047L6.75 2.38359L7.25273 2.13047L8.96484 1.27617L10.4098 2.10234L10.9055 2.38359L11.4258 2.15156L12.375 1.72969V16.2703L11.4258 15.8484L10.9055 15.6164L10.4098 15.8977L8.96484 16.7238L7.25273 15.8695L6.75 15.6164L6.24727 15.8695L4.53516 16.7238L3.09023 15.8977ZM0 18L1.125 17.5008L2.53125 16.875L4.5 18L6.75 16.875L9 18L10.9688 16.875L12.375 17.5008L13.5 18V16.7695V1.23047V0L12.375 0.499219L10.9688 1.125L9 0L6.75 1.125L4.5 0L2.53125 1.125L1.125 0.499219L0 0V1.23047V16.7695V18ZM3.375 5.0625H2.8125V6.1875H3.375H10.125H10.6875V5.0625H10.125H3.375ZM2.8125 11.8125V12.9375H3.375H10.125H10.6875V11.8125H10.125H3.375H2.8125ZM3.375 8.4375H2.8125V9.5625H3.375H10.125H10.6875V8.4375H10.125H3.375Z"
                      fill="#202020"
                    />
                  </svg>
                  <!-- eslint-enable max-len -->
                </span>
                <span class="text text-select-period">{{ label }}</span>
              </template>
            </aol-select>
          </div>
        </div>

        <!--    CHART     -->
        <div class="card card--rounded">
          <div class="card-body">
            <div class="metrics-controls" style="margin-bottom: 20px">
              <label
                v-for="(metric, index) in availableMetrics"
                :key="index"
                style="margin-right: 15px; cursor: pointer"
              >
                <input
                  type="checkbox"
                  :value="index"
                  v-model="selectedMetrics"
                  @change="updateChart"
                />
                {{ metric.label }}
              </label>
            </div>

            <div style="position: relative; height: 400px">
              <canvas ref="canvas"></canvas>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12">
        <div
          class="component-title d-flex justify-content-between align-items-center"
        >
          <span class="text">
            {{ $t('pages.plan.periodConsumptionTitleDetailed') }}
          </span>
        </div>
        <!--   switch period   -->
        <div class="period">
          <span class="text text-period">
            {{ $t('pages.plan.period') }}
          </span>
          <label class="switch_consumption">
            <input
              class="switch_consumption__input"
              type="checkbox"
              v-model="consumptions"
              :checked="showIsPersonalized"
              @change="switchPeriod"
            />

            <span class="switch_consumption__track">
              <span
                class="switch_consumption__text switch_consumption__text--left"
              >
                {{ $t('pages.plan.detailedPeriodConsumptionContract') }}
              </span>
              <span
                class="switch_consumption__text switch_consumption__text--right"
              >
                {{ $t('pages.plan.detailedPeriodConsumptionPersonalized') }}
              </span>
            </span>

            <span class="switch_consumption__thumb" aria-hidden="true"></span>
          </label>
        </div>
        <!-- CURRENT -->
        <div class="row" id="selectContractCycle" v-if="!showIsPersonalized">
          <div :class="[isMobileScreen ? 'col-12' : 'col-4']">
            <aol-select
              v-model="selectedMonth"
              @input="loadMonthDetails"
              :options="availableMonths"
              label="label"
              :reduce="(month) => month.value"
              class="form-select mb-4"
              style="
                width: 100%;
                margin: 0px;
                padding: 4px;
                background-color: transparent;
                border: none;
              "
            >
              <template v-slot:selected-option="{ label }">
                <icon name="calendar"></icon>
                <span class="text">{{ label }}</span>
              </template>
            </aol-select>
          </div>
          <div :class="[isMobileScreen ? 'col-12' : 'col-8']">
            <div
              v-if="isCurrentMonth"
              class="alert-simple alert-simple--bigger alert-simple-warning mb-4"
              role="alert"
            >
              <i class="icon fas fa-fw fa-leaf"></i>
              <span class="text">
                {{ $t('pages.plan.periodConsumptionAdvice') }}
              </span>
            </div>
          </div>
        </div>
        <!-- PERSONALIZED -->
        <div
          id="selectPersonalized"
          :class="[
            'row',
            isMobileScreen
              ? 'date_picker_range_adapter__row__mobile'
              : 'date_picker_range_adapter__row',
          ]"
          v-else
        >
          <div :class="[isMobileScreen ? 'col-12' : 'col-3']">
            <div class="form-control-icon">
              <icon name="calendar"></icon>
              <date-picker-range-adapter
                id="selectStartDate"
                class="date_picker_range_adapter"
                v-model="startDate"
                :min-date="startMinDate"
                :max-date="startMaxDate"
                :placeholder="$t('modal.date_settings.start_date_placeholder')"
                @input="loadStartAndFishDateDetails"
              />
            </div>
          </div>
          <div :class="[isMobileScreen ? 'col-12' : 'col-3']">
            <div class="form-control-icon">
              <icon name="calendar"></icon>
              <date-picker-range-adapter
                class="date_picker_range_adapter"
                id="selectFinishDate"
                v-model="finishDate"
                :min-date="startDate"
                :max-date="finishMaxDate"
                :placeholder="$t('modal.date_settings.finish_date_placeholder')"
                @input="loadStartAndFishDateDetails"
              />
            </div>
          </div>
          <div :class="[isMobileScreen ? 'col-12 col-md-auto' : 'col-1']">
            <button
              class="btn btn-primary"
              @click="loadConsumptionDetailed"
              :disabled="!startDate || !finishDate"
            >
              <icon name="magnifying-glass"></icon>
            </button>
          </div>
          <!--    Consumption Report Modal Reference     -->
          <consumption-report-modal
            @consumption-report-modal="getConsumptionReport()"
            ref="ConsumptionReportModal"
          />
          <!--    Consumption Report Button     -->
          <div :class="[isMobileScreen ? 'col-12' : 'col-5 text-end']">
            <button
              class="btn btn-primary-outline text-nowrap"
              @click="openConsumptionReportModal()"
              :disabled="!startDate || !finishDate"
            >
              <!-- eslint-disable max-len -->
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="18"
                viewBox="0 0 14 18"
                fill="none"
              >
                <path
                  d="M3.09023 15.8977L2.59453 15.6164L2.07422 15.8484L1.125 16.2703V1.72969L2.07422 2.15156L2.59453 2.38359L3.09023 2.10234L4.53516 1.27617L6.24727 2.13047L6.75 2.38359L7.25273 2.13047L8.96484 1.27617L10.4098 2.10234L10.9055 2.38359L11.4258 2.15156L12.375 1.72969V16.2703L11.4258 15.8484L10.9055 15.6164L10.4098 15.8977L8.96484 16.7238L7.25273 15.8695L6.75 15.6164L6.24727 15.8695L4.53516 16.7238L3.09023 15.8977ZM0 18L1.125 17.5008L2.53125 16.875L4.5 18L6.75 16.875L9 18L10.9688 16.875L12.375 17.5008L13.5 18V16.7695V1.23047V0L12.375 0.499219L10.9688 1.125L9 0L6.75 1.125L4.5 0L2.53125 1.125L1.125 0.499219L0 0V1.23047V16.7695V18ZM3.375 5.0625H2.8125V6.1875H3.375H10.125H10.6875V5.0625H10.125H3.375ZM2.8125 11.8125V12.9375H3.375H10.125H10.6875V11.8125H10.125H3.375H2.8125ZM3.375 8.4375H2.8125V9.5625H3.375H10.125H10.6875V8.4375H10.125H3.375Z"
                  fill="#19665B"
                />
              </svg>
              <span class="text" style="padding-left: 8px">
                {{ $t('pages.plan.consumptionReport.buttonLabel') }}
              </span>
              <!-- eslint-enable max-len -->
            </button>
          </div>
        </div>

        <div class="row" style="margin-bottom: 12px">
          <div class="col-12">
            <span class="text" v-if="!showIsPersonalized">
              {{
                $t('pages.plan.periodConsumption', {
                  start_at: formattedDate(monthDetails.start_at),
                  end_at: formattedDate(monthDetails.end_at),
                })
              }}
            </span>
            <span class="text" v-else>
              {{
                $t('pages.plan.periodConsumption', {
                  start_at: formattedDate(startDate),
                  end_at: formattedDate(finishDate),
                })
              }}
            </span>
          </div>
        </div>

        <!--    CARDS    -->
        <div class="row cards">
          <div
            :class="[
              'mb-4',
              isMobileScreen ? 'col-12' : 'col-4 col-sm-12 col-md-4 col-xl-4',
            ]"
          >
            <div class="card card-activity card-activity--envelope">
              <div class="card-body info-block">
                <div class="icon-block ms-2">
                  <icon
                    name="envelope-circle-check"
                    class="icon--envelope"
                  ></icon>
                </div>
                <div class="data-block">
                  <span
                    class="text d-block data-block__title text-card-metrics"
                  >
                    {{ monthDetails.envelopes }}
                  </span>
                  <div class="text text-card-label">
                    {{ $t('pages.plan.metrics.envelopes') }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            :class="[
              'mb-4',
              isMobileScreen ? 'col-12' : 'col-4 col-sm-12 col-md-4 col-xl-4',
            ]"
          >
            <div class="card card-activity card-activity--signature">
              <div class="card-body info-block">
                <div class="icon-block ms-2">
                  <icon name="signature" class="icon--signature"></icon>
                </div>
                <div class="data-block">
                  <span
                    class="text d-block data-block__title text-card-metrics"
                  >
                    {{ monthDetails.simpleSignatures }}
                  </span>
                  <div class="text text-card-label">
                    {{ $t('pages.plan.metrics.simple_signatures') }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            :class="[
              'mb-4',
              isMobileScreen ? 'col-12' : 'col-4 col-sm-12 col-md-4 col-xl-4',
            ]"
          >
            <div class="card card-activity card-activity--qualified">
              <div class="card-body info-block">
                <div class="icon-block ms-2">
                  <icon name="shield-halved" class="icon--qualified"></icon>
                </div>
                <div class="data-block">
                  <span
                    class="text d-block data-block__title text-card-metrics"
                  >
                    {{ monthDetails.qualifiedSignatures }}
                  </span>
                  <div class="text text-card-label">
                    {{ $t('pages.plan.metrics.qualified_signatures') }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row cards">
          <div
            :class="[
              'mb-4',
              isMobileScreen
                ? 'col-12'
                : 'col-3 col-sm-12 col-md-6 col-xl-3 mb-4',
            ]"
          >
            <div
              class="card card-activity card-activity--envelope-notification"
            >
              <div class="card-body info-block">
                <div class="icon-block ms-2">
                  <icon
                    name="envelope-open-text-regular"
                    class="icon--envelope-notification"
                  ></icon>
                </div>
                <div class="data-block">
                  <span
                    class="text d-block data-block__title text-card-metrics"
                  >
                    {{ monthDetails.emailNotifications }}
                  </span>
                  <div class="text text-card-label">
                    {{ $t('pages.plan.metrics.email_notifications') }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            :class="[
              'mb-4',
              isMobileScreen
                ? 'col-12'
                : 'col-3 col-sm-12 col-md-6 col-xl-3 mb-4',
            ]"
          >
            <div class="card card-activity card-activity--whatsapp">
              <div class="card-body info-block">
                <div class="icon-block ms-2">
                  <icon
                    name="whatsapp"
                    class="icon--whatsapp"
                    type="brands"
                  ></icon>
                </div>
                <div class="data-block">
                  <span
                    class="text d-block data-block__title text-card-metrics"
                  >
                    {{ monthDetails.whatsappNotifications }}
                  </span>
                  <div class="text text-card-label">
                    {{ $t('pages.plan.metrics.whatsapp_notifications') }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            :class="[
              'mb-4',
              isMobileScreen
                ? 'col-12'
                : 'col-3 col-sm-12 col-md-6 col-xl-3 mb-4',
            ]"
          >
            <div class="card card-activity card-activity--user">
              <div class="card-body info-block">
                <div class="icon-block ms-2">
                  <icon name="user" class="icon--user"></icon>
                </div>
                <div class="data-block">
                  <span
                    class="text d-block data-block__title text-card-metrics"
                  >
                    {{ monthDetails.users }}
                  </span>
                  <div class="text text-card-label">
                    {{ $t('pages.plan.metrics.users') }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            :class="[
              'mb-4',
              isMobileScreen
                ? 'col-12'
                : 'col-3 col-sm-12 col-md-6 col-xl-3 mb-4',
            ]"
          >
            <div class="card card-activity card-activity--storage">
              <div class="card-body info-block">
                <div class="icon-block ms-2">
                  <icon name="folder" class="icon--storage"></icon>
                </div>
                <div class="data-block">
                  <span
                    class="text d-block data-block__title text-card-metrics"
                  >
                    {{ monthDetails.storage }}
                  </span>
                  <div class="text text-card-label">
                    {{ $t('pages.plan.metrics.storage_mb') }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BillingHttp from '@/services/BillingHttp';
import Icon from '@/ui/atoms/Icon.vue';
import PlanIcon from '@/enums/PlanIcon';
import Chart from 'chart.js';
import DatePickerRangeAdapter from '@/ui/molecules/DatePickerRangeAdapter.vue';
import moment from 'moment';
import ConsumptionsPeriodType from '@/enums/ConsumptionsPeriodType';
import OrganizationsHttp from '@/services/OrganizationsHttp';
import ConsumptionReportModal from '@/modules/business/components/organisms/modals/ConsumptionReportModal.vue';

export default {
  name: 'ConsumptionDetails',
  components: {
    Icon,
    DatePickerRangeAdapter,
    ConsumptionReportModal,
  },
  data() {
    return {
      consumptions: [],
      consumptionsChart: [],
      PlanIcon,
      chart: null,
      showIsPersonalized: false,
      isFromChart: false,
      availableMetrics: [
        {
          label: this.$t('pages.plan.metrics.envelopes'),
          data: [],
          dataKey: 'envelopes',
          borderColor: '#FC628A',
          backgroundColor: 'transparent',
          lineTension: 0.1,
        },
        {
          label: this.$t('pages.plan.metrics.simple_signatures'),
          data: [],
          dataKey: 'simple_signatures',
          borderColor: '#919191',
          backgroundColor: 'transparent',
          lineTension: 0.1,
        },
        {
          label: this.$t('pages.plan.metrics.qualified_signatures'),
          data: [],
          dataKey: 'qualified_signatures',
          borderColor: '#FCAB53',
          backgroundColor: 'transparent',
          lineTension: 0.1,
        },
        {
          label: this.$t('pages.plan.metrics.email_notifications'),
          data: [],
          dataKey: 'email_notifications',
          borderColor: '#444C6D',
          backgroundColor: 'transparent',
          lineTension: 0.1,
        },
        {
          label: this.$t('pages.plan.metrics.whatsapp_notifications'),
          data: [],
          dataKey: 'whatsapp_notifications',
          borderColor: '#19D26A',
          backgroundColor: 'transparent',
          lineTension: 0.1,
        },
        {
          label: this.$t('pages.plan.metrics.users'),
          data: [],
          dataKey: 'users',
          borderColor: '#0080A3',
          backgroundColor: 'transparent',
          lineTension: 0.1,
        },
        {
          label: this.$t('pages.plan.metrics.storage_mb'),
          data: [],
          dataKey: 'storage_mb',
          borderColor: '#AF00E4',
          backgroundColor: 'transparent',
          lineTension: 0.1,
        },
      ],
      selectedMetrics: [0, 1, 2], // Indexes of the metrics selected by default in the chart
      labels: [],
      labelsChart: [],
      selectedMonth: '',
      selectedPeriodType: 'monthly',
      startDate: '',
      finishDate: '',
      availableMonths: [],
      monthDetails: {
        envelopes: 0,
        simpleSignatures: 0,
        qualifiedSignatures: 0,
        emailNotifications: 0,
        whatsappNotifications: 0,
        users: 0,
        storage: 0,
        start_at: '',
        end_at: '',
      },
    };
  },
  props: {
    plan: Object,
    planStatus: Object,
  },
  async created() {
    this.$loading(true);
    try {
      this.updatePageStrings();
    } finally {
      this.$loading(false);
    }
  },
  computed: {
    isLoading() {
      return this.$loading === true;
    },
    isPostpaid() {
      return this.$store.getters['subscription/isPostpaid'];
    },
    hasRecurringPlan() {
      return this.subscriptionState === 'recurring';
    },
    subscription() {
      return this.$store.state.subscription.plan;
    },
    subscriptionState() {
      return this.subscription.state;
    },
    filteredDatasets() {
      return this.selectedMetrics.map((index) => this.availableMetrics[index]);
    },
    isCurrentMonth() {
      const now = new Date();
      const currentYear = now.getFullYear();
      const currentMonth = String(now.getMonth() + 1).padStart(2, '0');
      const currentMonthValue = `${currentYear}-${currentMonth}`;

      return this.selectedMonth === currentMonthValue;
    },
    isPersonalized() {
      // if postpaid "Personalized" is selected; else "Contracted Cycle" is selected (uses isCurrentMonth);
      if (this.isPostpaid) {
        return true;
      }
      return false;
    },
    startMaxDate() {
      // startDate needs to be a day before today
      const date = new Date();
      date.setHours(0, 0, 0, 0);
      date.setDate(date.getDate() - 1);
      return date;
    },
    startMinDate() {
      const date = new Date(this.startMaxDate);
      date.setFullYear(date.getFullYear() - 1);
      return date;
    },
    finishMaxDate() {
      if (!this.startDate) {
        return null;
      }
      if (this.isFromChart) {
        // update cards from chart: max range is 1 year from startDate
        const date = new Date(this.startDate);
        date.setFullYear(date.getFullYear() + 1);
        return date;
      }
      // max range is today
      return new Date();
    },
    availableConsumptionPeriods() {
      // return translated options for ConsumptionsPeriodType enum
      return ConsumptionsPeriodType.values.map((options) => ({
        value: options.value,
        label: this.$t(ConsumptionsPeriodType.getByValue(options.value)),
      }));
    },
    isMobileScreen() {
      return this.$root.isMobileScreen || this.$root.isMobile;
    },
  },
  methods: {
    formattedDate(item) {
      return moment(item).format('DD/MM/YYYY') || null;
    },
    openConsumptionReportModal() {
      this.$refs.ConsumptionReportModal.$refs.modal.open();
    },
    async loadData() {
      this.$loading(true);
      const consumptions = await BillingHttp.getConsumptions();
      this.consumptions = consumptions.data;
      this.$loading(false);
    },
    async getDetailedConsumptions(startDate, endDate) {
      this.$loading(true);
      const consumptions = await BillingHttp.getDetailedConsumptions(
        startDate,
        endDate
      );
      this.consumptions = consumptions.data;
      this.$loading(false);
    },
    async getConsumptionsByPeriodType(periodType) {
      this.$loading(true);
      const consumptionsChart = await BillingHttp.getPeriodConsumptions(
        periodType
      );
      this.consumptionsChart = consumptionsChart.data;
      this.$loading(false);
    },
    async getConsumptionReport() {
      const params = {
        date_start: this.startDate,
        date_end: this.finishDate,
      };
      try {
        this.$loading(true);
        await OrganizationsHttp.generateConsumptionReport(params);
      } finally {
        this.$loading(false);
      }
    },
    updatePageStrings() {
      this.$store.dispatch('page/setTitle', this.$t('pages.plan.title'));
      this.$store.dispatch('page/setHead', this.$t('pages.plan.head'));
    },
    populateChartData() {
      const metricsMapping = [
        'envelopes',
        'simple_signatures',
        'qualified_signatures',
        'email_notifications',
        'whatsapp_notifications',
        'users',
        'storage_mb',
      ];

      this.labelsChart = [...this.labelsChart];
      this.availableMetrics.forEach((metric) => (metric.data = []));

      const sortedConsumptions = [...this.consumptionsChart].sort(
        (a, b) => new Date(a.start_at) - new Date(b.start_at)
      );

      metricsMapping.forEach((metricKey, index) => {
        this.availableMetrics[index].data = sortedConsumptions.map(
          (item) => item.consumptions[metricKey]
        );
      });
    },
    renderChart() {
      const ctx = this.$refs.canvas.getContext('2d');
      this.chart = new Chart(ctx, {
        type: 'line',
        data: {
          labels: [...this.labelsChart],
          datasets: this.filteredDatasets,
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          legend: {
            position: 'top',
          },
          title: {
            display: true,
            text: this.$t('pages.plan.chartInstructions'),
          },
        },
      });
    },
    updateChart() {
      if (this.chart) {
        this.chart.data.datasets = this.filteredDatasets;
        this.chart.update();
      }
    },
    formatPeriodToLabel(period) {
      const [year, month] = period.split('-');
      const date = new Date(year, month - 1);
      const monthFormatter = new Intl.DateTimeFormat(this.$i18n.locale, {
        month: 'long',
      });
      const yearFormatter = new Intl.DateTimeFormat(this.$i18n.locale, {
        year: 'numeric',
      });

      const monthName = monthFormatter.format(date);
      const yearNumber = yearFormatter.format(date);

      return `${
        monthName.charAt(0).toUpperCase() + monthName.slice(1)
      } ${yearNumber}`;
    },
    generateLabels() {
      // generate labels for option in "Contracted Cycle" select
      this.labels = this.consumptions.map((consumption) =>
        this.formatPeriodToLabel(consumption.period)
      );
    },
    generateChartLabels() {
      // generate labels for chart
      this.labelsChart = this.consumptionsChart.map((consumption) => {
        const m = moment(consumption.start_at);
        const monthIndex = m.month(); // month from 0 to 11
        const monthName = this.$t(
          `pages.plan.chartLabels.months.${monthIndex}`
        );
        const baseLabel = `${monthName} ${m.format('YYYY')}`;
        const weekStart = m.clone().startOf('week').format('DD');
        const weekEnd = m.clone().endOf('week').format('DD');
        const biwStart = m.clone().startOf('isoWeek').format('DD');
        const biwEndWeek = m.clone().add(6, 'days').format('DD');
        const from = this.$t('fromTo');
        const to = this.$t('toFrom');
        switch (this.selectedPeriodType) {
          case 'daily':
            return `${m.format('DD')} ${baseLabel}`;
          case 'weekly':
            return `${from} ${weekStart} ${to} ${weekEnd} ${baseLabel}`;
          case 'biweekly':
            return `${biwStart} - ${biwEndWeek} ${baseLabel}`;
          default:
            return baseLabel;
        }
      });
    },
    generateMonthsList() {
      const sortedConsumptions = [...this.consumptions].sort((a, b) => {
        const dateA = new Date(a.period + '-01');
        const dateB = new Date(b.period + '-01');
        return dateB - dateA;
      });
      this.availableMonths = sortedConsumptions.map((consumption) => ({
        value: consumption.reference_id,
        label: this.formatPeriodToLabel(consumption.period),
        period: consumption.period,
      }));
      this.selectedMonth = this.availableMonths[0]?.value;
    },
    async loadMonthDetails() {
      const index = this.consumptions.findIndex(
        (item) => item.reference_id === this.selectedMonth
      ); // when have repeated periods, but reference id is unique
      this.monthDetails = {
        envelopes: this.consumptions[index].consumptions['envelopes'],
        simpleSignatures:
          this.consumptions[index].consumptions['simple_signatures'],
        qualifiedSignatures:
          this.consumptions[index].consumptions['qualified_signatures'],
        emailNotifications:
          this.consumptions[index].consumptions['email_notifications'],
        whatsappNotifications:
          this.consumptions[index].consumptions['whatsapp_notifications'],
        users: this.consumptions[index].consumptions['users'],
        storage: this.consumptions[index].consumptions['storage_mb'],
        start_at: this.consumptions[index].start_at,
        end_at: this.consumptions[index].end_at,
      };
    },
    loadStartAndFishDateDetails(consumptions) {
      if (!consumptions) {
        return;
      }
      this.monthDetails = {
        envelopes: consumptions['envelopes'],
        simpleSignatures: consumptions['simple_signatures'],
        qualifiedSignatures: consumptions['qualified_signatures'],
        emailNotifications: consumptions['email_notifications'],
        whatsappNotifications: consumptions['whatsapp_notifications'],
        users: consumptions['users'],
        storage: consumptions['storage_mb'],
        start_at: this.startDate,
        end_at: this.finishDate,
      };
    },
    async switchPeriod(event) {
      this.showIsPersonalized = event.target.checked;
      if (!this.showIsPersonalized) {
        await this.loadData();
        return this.loadMonthDetails();
      }
      if (this.showIsPersonalized && this.startDate && this.finishDate) {
        await this.loadConsumptionDetailed();
      }
    },
    async loadConsumptionDetailed() {
      if (!this.startDate || !this.finishDate) {
        return;
      }
      // select startDate and finishDate for request getDetailedConsumptions
      this.startDate = moment(this.startDate).toISOString();
      this.finishDate = moment(this.finishDate).toISOString();
      await this.getDetailedConsumptions(this.startDate, this.finishDate);
      // reload cards info with new data
      this.loadStartAndFishDateDetails(this.consumptions);
    },
    async onPeriodTypeChange(periodType) {
      await this.loadChartDataByPeriodType(periodType);
      await this.updatePersonalizedConsuptionDetailedByChart();
    },
    async loadChartDataByPeriodType(periodType) {
      await this.getConsumptionsByPeriodType(periodType);
      this.generateChartLabels();
      this.showChartData();
    },
    showChartData() {
      this.populateChartData();
      if (this.chart) {
        this.updadateChartData();
      }
      if (!this.chart) {
        this.renderChart();
      }
    },
    updadateChartData() {
      // Update chart according to the selected period (monthly, quarterly, semi-annually, annually)
      this.chart.data.labels = [...this.labelsChart];
      this.chart.data.datasets = this.filteredDatasets;
      this.chart.update();
    },
    async updatePersonalizedConsuptionDetailedByChart() {
      // Change detailed consumption option to "Personalized", with the start and end dates following the chart period
      this.showIsPersonalized = true;
      this.isFromChart = true;
      this.startDate = this.consumptionsChart[0]?.start_at || null;
      this.finishDate =
        this.consumptionsChart[this.consumptionsChart.length - 1]?.end_at ||
        null;
      await this.loadConsumptionDetailed();
    },
  },
  watch: {
    startDate(val) {
      this.isFromChart = false;
      if (!val) {
        this.finishDate = null;
        return;
      }
      if (!this.finishDate) {
        return;
      }
      const finish = new Date(this.finishDate);
      const min = new Date(val); // startDate
      const max = this.finishMaxDate;
      if (finish < min || finish > max) {
        this.finishDate = null;
      }
    },
    finishDate() {
      this.isFromChart = false;
    },
  },
  async mounted() {
    await this.loadData(); // populate consumptions -  default is current month
    this.generateLabels(); // labels for select "Contracted Cycle"
    this.generateChartLabels(); // labels for chart
    this.generateMonthsList();
    await this.loadMonthDetails();
    this.showChartData();
    await this.loadChartDataByPeriodType(this.selectedPeriodType);
    this.startDate = moment(this.subscription.updated_at).isAfter(
      this.startMaxDate
    )
      ? this.startMaxDate.toISOString()
      : this.subscription.updated_at;
    this.finishDate = moment().toISOString();
  },
  beforeDestroy() {
    if (this.chart) {
      this.chart.destroy();
    }
  },
};
</script>
<style scoped>
.skeleton-lg {
  height: 24px;
  width: 130px;
}

.skeleton-sm {
  height: 15px;
  width: 40px;
}

.skeleton-md {
  height: 15px;
  width: 50px;
}

.skeleton {
  background: linear-gradient(90deg, #e0e0e0 25%, #f5f5f5 50%, #e0e0e0 75%);
  background-size: 200% 100%;
  animation: skeleton-loading 1.5s infinite;
  border-radius: 4px;
}

.metrics-controls {
  padding: 15px;
  background-color: #f5f5f5;
  border-radius: 4px;
}

.metrics-controls label {
  display: inline-flex;
  align-items: center;
  font-size: 15px;
}

.metrics-controls input[type='checkbox'] {
  margin-right: 5px;
}

.container-padding {
  padding-right: 86px;
}

.card-activity {
  height: 120px !important;
}

.card-activity .data-block {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.card-activity .icon-block {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.card-activity .tab-pane {
  margin-top: 0;
}

.icon--envelope {
  color: #fc628a !important;
}

.icon--signature {
  color: #919191 !important;
}

.icon--qualified {
  color: #fcab53 !important;
}

.icon--envelope-notification {
  color: #444c6d !important;
}

.icon--whatsapp {
  color: #19d26a !important;
}

.icon--user {
  color: #0080a3 !important;
}

.icon--storage {
  color: #af00e4 !important;
}

.card-activity--envelope {
  border-left: 6px solid #fc628a;
}

.card-activity--signature {
  border-left: 6px solid #919191;
}

.card-activity--qualified {
  border-left: 6px solid #fcab53;
}

.card-activity--envelope-notification {
  border-left: 6px solid #444c6d;
}

.card-activity--whatsapp {
  border-left: 6px solid #19d26a;
}

.card-activity--user {
  border-left: 6px solid #0080a3;
}

.card-activity--storage {
  border-left: 6px solid #af00e4;
}

.text-card-metrics {
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  color: #202020;
  line-height: 36px;
}

.text-card-label {
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  color: #202020;
  line-height: 21px;
}

.period {
  margin-top: 16px;
  margin-bottom: 16px;
}

.text-period {
  display: block;
  padding-bottom: 4px;
}

.switch_consumption {
  --h: 36px;
  --p: 4px;
  position: relative;
  display: inline-block;
  height: var(--h);
  margin-left: 0;
}

.switch_consumption__input {
  position: absolute;
  inset: 0;
  opacity: 0.001;
  margin: 0;
  cursor: pointer;
}

.switch_consumption__track {
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: center;
  height: 100%;
  padding: var(--p);
  border-radius: 360px;
  background: #ededed;
  width: max-content;
}

.switch_consumption__text {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  height: calc(var(--h) - var(--p) * 2);
  padding: 8px 16px;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  white-space: nowrap;
  color: #666666;
  z-index: 2;
}

.switch_consumption__thumb {
  position: absolute;
  top: var(--p);
  left: var(--p);
  width: calc(50% - var(--p));
  height: calc(var(--h) - var(--p) * 2);
  border-radius: 360px;
  background: #91d765;
  gap: 24px;
  transition: transform 180ms ease;
  z-index: 1;
}

.switch_consumption__input:checked ~ .switch_consumption__thumb {
  transform: translateX(100%);
}

.switch_consumption__input:not(:checked)
  ~ .switch_consumption__track
  .switch_consumption__text--left,
.switch_consumption__input:checked
  ~ .switch_consumption__track
  .switch_consumption__text--right {
  color: #19665b;
  font-weight: 600;
}

.date_picker_range_adapter {
  border-radius: 15px;
  border: 1px solid #ccc;
  background: #fff;
}

.date_picker_range_adapter__row {
  display: flex;
  padding-bottom: 16px;
  align-items: center;
  gap: 0;
  align-self: stretch;
}

.date_picker_range_adapter__row__mobile {
  display: flex;
  padding-bottom: 16px;
  align-items: center;
  gap: 4px;
  align-self: stretch;
}

.btn-primary {
  padding-right: 6px !important;
  align-content: center !important;
  align-items: center !important;
  margin: 0 !important;
  min-height: 44px;
  min-width: 44px;
}

.text-select-period {
  color: #202020 !important;
  font-weight: 400 !important;
  font-size: 14px !important;
}

.row-period-consumption-period {
  align-items: flex-end;
}

@media (max-width: 767px) {
  .btn-primary {
    width: 100%;
    max-width: 120px;
  }
}

@keyframes skeleton-loading {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}
</style>
